import { BlocksTabPanel } from 'blocks-nextjs/blocks-web-components/components/tab-panel/tab-panel';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatTabPanel = createComponent({
  react: React,
  tagName: 'cat-tab-panel',
  elementClass: BlocksTabPanel
});
